import {initializeApp}  from 'firebase/app'
import {getFirestore} from 'firebase/firestore'

const config = {
  apiKey: "AIzaSyDLundkWMBxOuGYMx8QchDeXxPIgGLHxn0",
  authDomain: "stack-board.firebaseapp.com",
  projectId: "stack-board",
  storageBucket: "stack-board.appspot.com",
  messagingSenderId: "1072229219900",
  appId: "1:1072229219900:web:12770ac423103120c6cd39",
  measurementId: "G-F5TPCXRFLH"
  };
    const db =  initializeApp(config);

    export default getFirestore()
